import cx from 'classnames';
import {useIsLargishAndUp} from '~library/hooks/useMatchQuery';
import {cdnPath} from '~libSass/base/_exports.sass';

export const PlaceholderAd = ({sidePanel, hideRealAds, spacerOnly}) => {
  const isLargishAndUp = useIsLargishAndUp();
  const GoogleAdUnitDesktop = `${cdnPath}banners/google/amazon-banner.png`;
  const GoogleAdUnitMobile = `${cdnPath}banners/google/amazon-banner-mobile.png`;
  const GoogleAdUnitSidePanel = `${cdnPath}banners/google/amazon-skyscraper.png`;
  const placeholderBanner = isLargishAndUp ? GoogleAdUnitDesktop : GoogleAdUnitMobile;
  const placeholderAdUnit = sidePanel ? GoogleAdUnitSidePanel : placeholderBanner;
  const placeholderWidth = isLargishAndUp ? 728 : 300;
  const placeholderHeight = isLargishAndUp ? 90 : 50;

  return (
    <div
      className={cx('placeholder-banner', {
        'placeholder-banner--blurry': hideRealAds,
        skyscraper: sidePanel,
        mobile: !isLargishAndUp,
      })}
      style={{
        backgroundImage: spacerOnly ? null : `url("${placeholderAdUnit}")`,
        height: spacerOnly ? placeholderHeight : null,
        width: spacerOnly ? placeholderWidth : null,
      }}
    >
      {!spacerOnly
        ? <img
            src={placeholderAdUnit}
            alt=""
            className="placeholder-banner__image"
            width={sidePanel ? 300 : placeholderWidth}
            height={sidePanel ? 600 : placeholderHeight}
          />
        : null}
    </div>
  );
};
